/* Somnair — Nose Strips (zone ns).
   1) Buy state : chaque [data-smn-buy] synchronise pack + mode (One-Time /
      "Subscribe & Save"). AUCUN prix n'est écrit par le JS : tous les
      affichages sont pré-rendus en Liquid depuis variant.price et montrés/
      masqués via data-mode / data-smn-tiershow (règles dans somnair-ns.css).
      Le JS ne touche qu'à l'input hidden name="id" (variante réellement
      facturée), à l'input name="selling_plan" (plan d'abonnement, soumis
      uniquement en mode sub) et à la barre free-shipping.
      Mode sub = MÊME variante + son selling plan (data-sp-sub, rendu depuis
      variant.selling_plan_allocations), comme la référence au.respire.com.
      Sans plan exposé pour le pack sélectionné, on force le mode one-time :
      poster un abonnement inexistant ferait échouer /cart/add.
   2) ATC : AJAX add + ouverture du cart drawer Shrine (même voie que le
      formulaire patches de somnair-atc.js). Fallback natif avec
      return_to=/checkout — JAMAIS /cart (page invisible : license guard). */
(function () {
  'use strict';
  if (window.__somnairNsBound) return;
  window.__somnairNsBound = true;

  var CHECKOUT_URL = '/checkout';

  /* ---------------------------------------------------- buy state ---- */
  function initBuy(root) {
    if (root.dataset.smnInit === 'true') return;
    root.dataset.smnInit = 'true';

    var idInput = root.querySelector('input[name="id"][data-smn-id]');
    var spInput = root.querySelector('input[name="selling_plan"][data-smn-sp]');

    function currentMode() {
      var cb = root.querySelector('[data-smn-mode-toggle]');
      if (cb) return cb.checked ? 'sub' : 'ot';
      var r = root.querySelector('input[data-smn-mode]:checked');
      return r ? r.value : (root.dataset.mode || 'ot');
    }
    function activePack() {
      return (
        root.querySelector('input[data-smn-pack]:checked') ||
        root.querySelector('input[data-smn-pack]')
      );
    }

    function update() {
      var pack = activePack();
      if (!pack) return;
      var mode = currentMode();
      // un pack sans variante "sub" retombe sur one-time (jamais d'id vide)
      if (mode === 'sub' && !pack.dataset.vidSub) mode = 'ot';
      // pas de plan exposé pour ce pack => jamais de mode abonnement (le Liquid
      // n'émet data-vid-sub/data-sp-sub que si l'abonnement est réellement achetable)
      if (mode === 'sub' && !pack.dataset.spSub && !pack.dataset.vidSub) mode = 'ot';
      root.dataset.mode = mode;
      root.dataset.tier = pack.value;

      var vid = mode === 'sub' ? pack.dataset.vidSub : pack.dataset.vidOt;
      if (idInput && vid) idInput.value = vid;

      // le selling plan n'accompagne QUE la variante d'abonnement ; désactivé,
      // l'input n'est pas soumis, donc un achat one-time reste one-time
      if (spInput) {
        var sp = mode === 'sub' ? pack.dataset.spSub : '';
        spInput.value = sp || '';
        spInput.disabled = !sp;
      }

      root.querySelectorAll('[data-smn-tiershow]').forEach(function (el) {
        el.classList.toggle(
          'is-active',
          el.getAttribute('data-smn-tiershow') === pack.value
        );
      });

      var ship = root.querySelector('[data-smn-ship]');
      if (ship) {
        var threshold = parseInt(ship.dataset.threshold, 10) || 0;
        var cents = parseInt(
          mode === 'sub' ? pack.dataset.priceSub : pack.dataset.priceOt,
          10
        ) || 0;
        // L'abonnement offre la livraison : on deverrouille sans condition de seuil.
        var freeOnSub = ship.dataset.freeOnSub === 'true';
        var subFree = freeOnSub && mode === 'sub';
        var unlocked = subFree || (threshold > 0 && cents >= threshold);
        ship.classList.toggle('smn-ship--unlocked', unlocked);
        ship.classList.toggle('smn-ship--sub', subFree);
        var gap = ship.querySelector('[data-smn-ship-gap]');
        if (gap && !unlocked) {
          gap.textContent = '$' + ((threshold - cents) / 100).toFixed(2);
        }
      }
    }

    root.addEventListener('change', update);
    update();
  }

  function initAll(scope) {
    (scope || document)
      .querySelectorAll('[data-smn-buy]')
      .forEach(initBuy);
  }
  initAll(document);
  document.addEventListener('shopify:section:load', function (evt) {
    initAll(evt.target);
  });

  /* -------------------------------------------- ATC : drawer AJAX ---- */
  document.addEventListener('submit', function (evt) {
    var form = evt.target && evt.target.closest
      ? evt.target.closest('form.smn-form')
      : null;
    if (!form || form.dataset.somnairNative === 'true') return;

    var drawer = document.querySelector('cart-drawer');
    var canDrawer = !!(
      drawer &&
      typeof drawer.renderContents === 'function' &&
      window.routes &&
      window.routes.cart_add_url
    );

    evt.preventDefault();

    var button = form.querySelector('[type="submit"]');
    var originalHtml = button ? button.innerHTML : null;
    if (button) { button.disabled = true; button.innerHTML = '…'; }
    var restore = function () {
      if (button) { button.disabled = false; button.innerHTML = originalHtml; }
    };

    var nativeFallback = function () {
      // Dégradé : POST natif vers /checkout. PAS /cart (invisible sur ce thème).
      if (!form.querySelector('input[name="return_to"]')) {
        var rt = document.createElement('input');
        rt.type = 'hidden';
        rt.name = 'return_to';
        rt.value = CHECKOUT_URL;
        form.appendChild(rt);
      }
      form.dataset.somnairNative = 'true';
      form.submit();
    };

    if (!canDrawer) {
      restore();
      nativeFallback();
      return;
    }

    var sectionIds = ['cart-drawer', 'cart-icon-bubble'];
    try {
      if (typeof drawer.getSectionsToRender === 'function') {
        sectionIds = drawer.getSectionsToRender().map(function (s) { return s.id; });
      }
    } catch (e) { /* défauts conservés */ }

    var body = new FormData(form);
    body.append('sections', sectionIds.join(','));
    body.append('sections_url', window.location.pathname);

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    })
      .then(function (response) { return response.json(); })
      .then(function (response) {
        if (response.status) {
          throw new Error(response.description || response.message || 'ATC failed');
        }
        if (typeof drawer.setActiveElement === 'function') {
          drawer.setActiveElement(document.activeElement);
        }
        drawer.classList.remove('is-empty');
        drawer.renderContents(response);
        restore();
      })
      .catch(function () {
        restore();
        nativeFallback();
      });
  });
})();
